const getters = {
  loginStatus: state => state.user.loginStatus,
  cn: state => state.user.Cn,
  homeUrl: state => state.user.HomeUrl,
  iccid: state => state.user.Iccid,
  cer_url: state => state.user.CerUrl,
  openid: state => state.user.Openid,
  appid: state => state.user.Appid,
  type: state => state.user.Type,
  prepare: state => state.user.Prepare,
  token: state => state.user.Token,
  template: state => state.user.Template
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js